var _a;
import { generateHooks } from "../generators/generator.hooks";
import { GENERATOR_PARAMS } from "./settlement.constants";
export var useDetail = (_a = generateHooks(GENERATOR_PARAMS), _a.useDetail), useGetAll = _a.useGetAll, usePaged = _a.usePaged, useCount = _a.useCount, useUpdate = _a.useUpdate, useRemove = _a.useRemove;
